(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CV_rising-brand"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rising-brand')) {
    class RisingBrand extends HTMLElement {
      connectedCallback() {
        // 담기(+) 버튼은 이벤트 위임: 자식 요소가 아직 파싱되기 전에 호출되어도 항상 동작
        if (!this.__rbDelegated) {
          this.__rbDelegated = true;
          this.addEventListener('click', (e) => {
            const btn = e.target && e.target.closest ? e.target.closest('[data-rb-add]') : null;
            if (btn && this.contains(btn)) { e.preventDefault(); this.quickAdd(btn); }
          });
        }
        // 스크립트가 head에서 먼저 실행되면 이 시점엔 자식 DOM이 비어 있을 수 있으므로 파싱 완료 후 초기화
        const start = () => { if (this.__rbInit) return; this.__rbInit = true; this.init(); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
        else start();
      }

      init() {
        this.tabs = Array.from(this.querySelectorAll('[data-rb-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-rb-panel]'));
        this.live = this.querySelector('[data-rb-live]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, false));
          tab.addEventListener('keydown', (e) => this.onTabKey(e, i));
        });
        this.panels.forEach((p) => this.initPanel(p));

        const modal = this.querySelector('[data-rb-modal]');
        if (modal) {
          modal.querySelectorAll('[data-rb-close]').forEach((b) => b.addEventListener('click', () => modal.close()));
          modal.addEventListener('click', (e) => { if (e.target === modal) modal.close(); });
        }

        this.io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            const v = en.target;
            if (!v.__rbUserPaused && en.isIntersecting && this.isActive(v)) this.safePlay(v);
            else v.pause();
          });
        }, { threshold: 0.4 });
        this.querySelectorAll('[data-rb-video]').forEach((v) => this.io.observe(v));
        this.activeVideo();

        // 다른 탭/앱으로 전환하면 소리가 계속 나지 않도록 정지, 돌아오면 재개
        this.onVisibility = () => {
          const modal = this.querySelector('[data-rb-modal]');
          if (document.hidden) {
            this.querySelectorAll('video').forEach((v) => { v.__rbHiddenPlaying = !v.paused; v.pause(); });
          } else {
            this.querySelectorAll('video').forEach((v) => {
              if (v.__rbHiddenPlaying && !v.__rbUserPaused) this.safePlay(v);
              v.__rbHiddenPlaying = false;
            });
          }
        };
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      isActive(video) {
        const panel = video.closest('[data-rb-panel]');
        return panel && !panel.hidden;
      }

      select(index, focus) {
        this.tabs.forEach((t, i) => {
          const on = i === index;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !on;
        });
        if (focus) this.tabs[index].focus();
        this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'center' });
        this.querySelectorAll('[data-rb-video]').forEach((v) => v.pause());
        this.activeVideo();
        const track = this.panels[index] && this.panels[index].querySelector('[data-rb-track]');
        if (track) track.dispatchEvent(new Event('scroll'));
      }

      onTabKey(e, i) {
        const n = this.tabs.length;
        let next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % n;
        else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        if (next !== null) { e.preventDefault(); this.select(next, true); }
      }

      activeVideo() {
        const panel = this.panels.find((p) => !p.hidden);
        const v = panel && panel.querySelector('[data-rb-video]');
        if (v && this.autoplay && !v.__rbUserPaused) this.safePlay(v);
      }

      safePlay(v) {
        if (v.preload === 'none') v.preload = 'metadata';
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      }

      initPanel(panel) {
        const track = panel.querySelector('[data-rb-track]');
        const nav = panel.querySelector('[data-rb-nav]');
        const prev = panel.querySelector('[data-rb-prev]');
        const next = panel.querySelector('[data-rb-next]');
        const update = () => {
          if (!track) return;
          const max = track.scrollWidth - track.clientWidth;
          // 내용이 넘치지 않으면(상품 4개 이하 등) 스크롤 UI 숨김
          if (nav && !panel.hidden) nav.hidden = max <= 2;
          if (prev) prev.disabled = track.scrollLeft <= 1;
          if (next) next.disabled = track.scrollLeft >= max - 1;
        };
        if (track) {
          track.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update);
          update();
        }
        const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: this.reduceMotion ? 'auto' : 'smooth' });
        if (prev) prev.addEventListener('click', () => step(-1));
        if (next) next.addEventListener('click', () => step(1));

        const video = panel.querySelector('[data-rb-video]');
        if (video) this.initVideo(panel, video);

      }

      initVideo(panel, video) {
        const sound = panel.querySelector('[data-rb-sound]');
        const play = panel.querySelector('[data-rb-play]');
        video.muted = true;
        const syncSound = () => {
          if (!sound) return;
          const on = !video.muted && video.volume > 0;
          sound.setAttribute('aria-pressed', on ? 'true' : 'false');
          sound.setAttribute('aria-label', on ? '소리 끄기' : '소리 켜기');
        };
        if (sound) sound.addEventListener('click', () => {
          if (video.muted || video.volume === 0) { video.volume = 1; video.muted = false; }
          else { video.muted = true; }
          syncSound();
          if (!video.muted && video.paused && !video.__rbUserPaused) this.safePlay(video);
        });
        video.addEventListener('volumechange', syncSound);
        // 오디오 트랙이 없는 영상이면 소리 버튼 숨김 (지원 브라우저에서만 판별)
        video.addEventListener('loadedmetadata', () => {
          const noAudio = video.mozHasAudio === false;
          if (noAudio && sound) sound.hidden = true;
        });
        if (play) play.addEventListener('click', () => {
          if (video.paused) { video.__rbUserPaused = false; this.safePlay(video); }
          else { video.__rbUserPaused = true; video.pause(); }
        });
        video.addEventListener('play', () => { if (play) { play.setAttribute('aria-pressed', 'true'); play.setAttribute('aria-label', '일시정지'); } });
        video.addEventListener('pause', () => { if (play) { play.setAttribute('aria-pressed', 'false'); play.setAttribute('aria-label', '재생'); } });
        if (!this.autoplay) { video.__rbUserPaused = true; }
        const expand = panel.querySelector('[data-rb-expand]');
        if (expand) expand.addEventListener('click', () => this.openModal(video, expand));
      }

      openModal(src, opener) {
        const modal = this.querySelector('[data-rb-modal]');
        const body = this.querySelector('[data-rb-modal-body]');
        if (!modal || !body || typeof modal.showModal !== 'function') return;
        const wasPlaying = !src.paused;
        src.pause();
        body.textContent = '';
        const big = document.createElement('video');
        big.controls = true;
        big.loop = true;
        big.playsInline = true;
        big.muted = false;
        big.setAttribute('aria-label', src.getAttribute('aria-label') || '');
        const poster = src.getAttribute('poster');
        if (poster) big.setAttribute('poster', poster);
        src.querySelectorAll('source').forEach((s) => big.appendChild(s.cloneNode(true)));
        body.appendChild(big);
        const start = src.currentTime || 0;
        big.addEventListener('loadedmetadata', () => { try { big.currentTime = start; } catch (e) {} }, { once: true });
        const close = () => {
          big.pause();
          body.textContent = '';
          modal.removeEventListener('close', close);
          if (opener && opener.isConnected) opener.focus();
          if (wasPlaying && !src.__rbUserPaused) this.safePlay(src);
        };
        modal.addEventListener('close', close);
        modal.showModal();
        const p = big.play();
        if (p && p.catch) p.catch(() => {});
      }

      async quickAdd(btn) {
        const id = Number(btn.dataset.variantId);
        if (!Number.isInteger(id) || id <= 0 || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        btn.disabled = true;
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        try {
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] })
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data && data.description ? String(data.description) : 'add_failed');

          // 최신 카트를 받아 테마(카트 카운트/드로어)가 갱신할 수 있도록 이벤트 발행
          let cart = null;
          try { cart = await (await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })).json(); } catch (e) {}
          const detail = { variantId: id, cart, items: data && data.items };
          document.dispatchEvent(new CustomEvent('rising-brand:cart-added', { detail }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail }));

          btn.classList.add('is-added');
          this.say('장바구니에 담았습니다.');
          setTimeout(() => btn.classList.remove('is-added'), 1600);

          if (this.dataset.afterAdd === 'cart_page' && this.dataset.cartUrl) {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch (err) {
          const msg = err && err.message && err.message !== 'add_failed' ? err.message : '장바구니에 담지 못했습니다. 다시 시도해 주세요.';
          this.say(msg);
        } finally {
          btn.disabled = false;
        }
      }

      say(msg) { if (this.live) this.live.textContent = msg; }
    }
    customElements.define('rising-brand', RisingBrand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CV_short_pdlist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cv-short-bn-pdlist')) {
    class CVShortBnPdlist extends HTMLElement {
      connectedCallback() {
        // 담기(+) 버튼은 이벤트 위임: 자식 요소가 아직 파싱되기 전에 호출되어도 항상 동작
        if (!this.__rbDelegated) {
          this.__rbDelegated = true;
          this.addEventListener('click', (e) => {
            const btn = e.target && e.target.closest ? e.target.closest('[data-rb-add]') : null;
            if (btn && this.contains(btn)) { e.preventDefault(); this.quickAdd(btn); }
          });
        }
        // 스크립트가 head에서 먼저 실행되면 이 시점엔 자식 DOM이 비어 있을 수 있으므로 파싱 완료 후 초기화
        const start = () => { if (this.__rbInit) return; this.__rbInit = true; this.init(); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
        else start();
      }

      init() {
        this.tabs = Array.from(this.querySelectorAll('[data-rb-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-rb-panel]'));
        this.live = this.querySelector('[data-rb-live]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, false));
          tab.addEventListener('keydown', (e) => this.onTabKey(e, i));
        });
        this.panels.forEach((p) => this.initPanel(p));

        const modal = this.querySelector('[data-rb-modal]');
        if (modal) {
          modal.querySelectorAll('[data-rb-close]').forEach((b) => b.addEventListener('click', () => modal.close()));
          modal.addEventListener('click', (e) => { if (e.target === modal) modal.close(); });
        }

        this.io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            const v = en.target;
            if (!v.__rbUserPaused && en.isIntersecting && this.isActive(v)) this.safePlay(v);
            else v.pause();
          });
        }, { threshold: 0.4 });
        this.querySelectorAll('[data-rb-video]').forEach((v) => this.io.observe(v));
        this.activeVideo();

        // 다른 탭/앱으로 전환하면 소리가 계속 나지 않도록 정지, 돌아오면 재개
        this.onVisibility = () => {
          const modal = this.querySelector('[data-rb-modal]');
          if (document.hidden) {
            this.querySelectorAll('video').forEach((v) => { v.__rbHiddenPlaying = !v.paused; v.pause(); });
          } else {
            this.querySelectorAll('video').forEach((v) => {
              if (v.__rbHiddenPlaying && !v.__rbUserPaused) this.safePlay(v);
              v.__rbHiddenPlaying = false;
            });
          }
        };
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      isActive(video) {
        const panel = video.closest('[data-rb-panel]');
        return panel && !panel.hidden;
      }

      select(index, focus) {
        this.tabs.forEach((t, i) => {
          const on = i === index;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !on;
        });
        if (focus) this.tabs[index].focus();
        this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'center' });
        this.querySelectorAll('[data-rb-video]').forEach((v) => v.pause());
        this.activeVideo();
        const track = this.panels[index] && this.panels[index].querySelector('[data-rb-track]');
        if (track) track.dispatchEvent(new Event('scroll'));
      }

      onTabKey(e, i) {
        const n = this.tabs.length;
        let next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % n;
        else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        if (next !== null) { e.preventDefault(); this.select(next, true); }
      }

      activeVideo() {
        const panel = this.panels.find((p) => !p.hidden);
        const v = panel && panel.querySelector('[data-rb-video]');
        if (v && this.autoplay && !v.__rbUserPaused) this.safePlay(v);
      }

      safePlay(v) {
        if (v.preload === 'none') v.preload = 'metadata';
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      }

      initPanel(panel) {
        const track = panel.querySelector('[data-rb-track]');
        const nav = panel.querySelector('[data-rb-nav]');
        const prev = panel.querySelector('[data-rb-prev]');
        const next = panel.querySelector('[data-rb-next]');
        const update = () => {
          if (!track) return;
          const max = track.scrollWidth - track.clientWidth;
          // 가로로 넘치는 경우에만 PC 호버 화살표를 표시
          if (nav && !panel.hidden) nav.hidden = max <= 2;
          if (prev) prev.disabled = track.scrollLeft <= 1;
          if (next) next.disabled = track.scrollLeft >= max - 1;
        };
        if (track) {
          track.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update);
          update();
        }
        const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: this.reduceMotion ? 'auto' : 'smooth' });
        if (prev) prev.addEventListener('click', () => step(-1));
        if (next) next.addEventListener('click', () => step(1));

        const video = panel.querySelector('[data-rb-video]');
        if (video) this.initVideo(panel, video);

      }

      initVideo(panel, video) {
        const sound = panel.querySelector('[data-rb-sound]');
        const play = panel.querySelector('[data-rb-play]');
        video.muted = true;
        const syncSound = () => {
          if (!sound) return;
          const on = !video.muted && video.volume > 0;
          sound.setAttribute('aria-pressed', on ? 'true' : 'false');
          sound.setAttribute('aria-label', on ? '소리 끄기' : '소리 켜기');
        };
        if (sound) sound.addEventListener('click', () => {
          if (video.muted || video.volume === 0) { video.volume = 1; video.muted = false; }
          else { video.muted = true; }
          syncSound();
          if (!video.muted && video.paused && !video.__rbUserPaused) this.safePlay(video);
        });
        video.addEventListener('volumechange', syncSound);
        // 오디오 트랙이 없는 영상이면 소리 버튼 숨김 (지원 브라우저에서만 판별)
        video.addEventListener('loadedmetadata', () => {
          const noAudio = video.mozHasAudio === false;
          if (noAudio && sound) sound.hidden = true;
        });
        if (play) play.addEventListener('click', () => {
          if (video.paused) { video.__rbUserPaused = false; this.safePlay(video); }
          else { video.__rbUserPaused = true; video.pause(); }
        });
        video.addEventListener('play', () => { if (play) { play.setAttribute('aria-pressed', 'true'); play.setAttribute('aria-label', '일시정지'); } });
        video.addEventListener('pause', () => { if (play) { play.setAttribute('aria-pressed', 'false'); play.setAttribute('aria-label', '재생'); } });
        if (!this.autoplay) { video.__rbUserPaused = true; }
        const expand = panel.querySelector('[data-rb-expand]');
        if (expand) expand.addEventListener('click', () => this.openModal(video, expand));
      }

      openModal(src, opener) {
        const modal = this.querySelector('[data-rb-modal]');
        const body = this.querySelector('[data-rb-modal-body]');
        if (!modal || !body || typeof modal.showModal !== 'function') return;
        const wasPlaying = !src.paused;
        src.pause();
        body.textContent = '';
        const big = document.createElement('video');
        big.controls = true;
        big.loop = true;
        big.playsInline = true;
        big.muted = false;
        big.setAttribute('aria-label', src.getAttribute('aria-label') || '');
        const poster = src.getAttribute('poster');
        if (poster) big.setAttribute('poster', poster);
        src.querySelectorAll('source').forEach((s) => big.appendChild(s.cloneNode(true)));
        body.appendChild(big);
        const start = src.currentTime || 0;
        big.addEventListener('loadedmetadata', () => { try { big.currentTime = start; } catch (e) {} }, { once: true });
        const close = () => {
          big.pause();
          body.textContent = '';
          modal.removeEventListener('close', close);
          if (opener && opener.isConnected) opener.focus();
          if (wasPlaying && !src.__rbUserPaused) this.safePlay(src);
        };
        modal.addEventListener('close', close);
        modal.showModal();
        const p = big.play();
        if (p && p.catch) p.catch(() => {});
      }

      async quickAdd(btn) {
        const id = Number(btn.dataset.variantId);
        if (!Number.isInteger(id) || id <= 0 || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        btn.disabled = true;
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        try {
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] })
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data && data.description ? String(data.description) : 'add_failed');

          // 최신 카트를 받아 테마(카트 카운트/드로어)가 갱신할 수 있도록 이벤트 발행
          let cart = null;
          try { cart = await (await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })).json(); } catch (e) {}
          const detail = { variantId: id, cart, items: data && data.items };
          document.dispatchEvent(new CustomEvent('cv-short-bn-pdlist:cart-added', { detail }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail }));

          btn.classList.add('is-added');
          this.say('장바구니에 담았습니다.');
          setTimeout(() => btn.classList.remove('is-added'), 1600);

          if (this.dataset.afterAdd === 'cart_page' && this.dataset.cartUrl) {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch (err) {
          const msg = err && err.message && err.message !== 'add_failed' ? err.message : '장바구니에 담지 못했습니다. 다시 시도해 주세요.';
          this.say(msg);
        } finally {
          btn.disabled = false;
        }
      }

      say(msg) { if (this.live) this.live.textContent = msg; }
    }
    customElements.define('cv-short-bn-pdlist', CVShortBnPdlist);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-events"]) return;
  try {
    
  if (!customElements.get('cj-events')) {
    customElements.define('cj-events', class extends HTMLElement {
      connectedCallback() {
        this.updateEventStates = () => {
          const now = Date.now();
          let nextUpdate = 2147483647;
          const list = this.querySelector('.ev-list');
          const cards = Array.from(list.querySelectorAll('.ev-card'));
          const statusOrder = { ongoing: 0, upcoming: 1, ended: 2 };
          const statusLabels = {
            ongoing: this.dataset.ongoingLabel,
            upcoming: this.dataset.upcomingLabel,
            ended: this.dataset.endedLabel,
          };
          cards.forEach((card) => {
            const start = Date.parse(`${card.dataset.startDate}T00:00:00${this.dataset.timezoneOffset}`);
            const end = Date.parse(`${card.dataset.endDate}T23:59:59.999${this.dataset.timezoneOffset}`);
            let status = 'ongoing';
            if (Number.isFinite(end) && now > end) {
              status = 'ended';
            } else if (Number.isFinite(start) && now < start) {
              status = 'upcoming';
            }

            card.dataset.status = status;
            card.querySelector('.ev-badge').textContent = statusLabels[status];
            if (status === 'upcoming') nextUpdate = Math.min(nextUpdate, start - now);
            if (status !== 'ended' && Number.isFinite(end)) nextUpdate = Math.min(nextUpdate, end - now + 1);
          });
          const sortedCards = [...cards].sort((first, second) => {
            const statusDifference = statusOrder[first.dataset.status] - statusOrder[second.dataset.status];
            if (statusDifference) return statusDifference;
            const firstDate = first.dataset.startDate || '9999-12-31';
            const secondDate = second.dataset.startDate || '9999-12-31';
            return firstDate.localeCompare(secondDate);
          });
          if (sortedCards.some((card, index) => card !== cards[index])) list.append(...sortedCards);
          this.timer = window.setTimeout(this.updateEventStates, nextUpdate);
        };
        this.updateEventStates();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('cj-pdp-divider-alignment')) {
    customElements.define('cj-pdp-divider-alignment', class extends HTMLElement {
      connectedCallback() {
        this.productRoot = this.closest('.main-product');
        if (!this.productRoot) return;
        this.offsets = new Map();
        this.frame = 0;
        this.schedule = () => {
          if (this.frame || !this.isConnected) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.alignDividers();
          });
        };
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.productRoot);
        this.observer.observe(document.body);
        const details = this.productRoot.querySelector('.main-product__details');
        if (details) this.observer.observe(details);
        window.addEventListener('resize', this.schedule);
        window.addEventListener('scroll', this.schedule, { passive: true });
        this.productRoot.addEventListener('click', this.schedule);
        document.fonts?.addEventListener('loadingdone', this.schedule);
        document.fonts?.ready.then(this.schedule);
        this.schedule();
      }

      resetDividers() {
        this.offsets?.forEach((offset, divider) => {
          divider.style.removeProperty('--cj-divider-offset');
          divider.removeAttribute('data-cj-divider-aligned');
        });
        this.offsets?.clear();
      }

      alignDividers() {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          this.resetDividers();
          return;
        }
        const ratio = window.devicePixelRatio || 1;
        const dividers = this.productRoot.querySelectorAll(
          '[class*="ai-collapsible-divider-"], [class*="ai-how-to-use-divider-"]'
        );
        const updates = Array.from(dividers, divider => {
          const rect = divider.getBoundingClientRect();
          if (!rect.height) return null;
          const previous = this.offsets.get(divider) || 0;
          const top = rect.top + window.scrollY - previous;
          const offset = Math.round((Math.round(top * ratio) / ratio - top) * 1000000) / 1000000;
          return { divider, previous, offset };
        });
        updates.forEach(update => {
          if (!update) return;
          const { divider, previous, offset } = update;
          if (this.offsets.has(divider) && Math.abs(previous - offset) < 0.0001) return;
          divider.style.setProperty('--cj-divider-offset', `${offset}px`);
          divider.setAttribute('data-cj-divider-aligned', '');
          this.offsets.set(divider, offset);
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        window.removeEventListener('resize', this.schedule);
        window.removeEventListener('scroll', this.schedule);
        this.productRoot?.removeEventListener('click', this.schedule);
        document.fonts?.removeEventListener('loadingdone', this.schedule);
        this.resetDividers();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
